import { AxiosResponse } from 'axios';

import {
    API_CASINO_CHANGE_SEO_TAG_FOR_GAME,
    API_CASINO_GAME_TYPES,
} from '../../../../crm/casino/pages/Helpers/CrmApiUrls';
import AbstractCasinoCRMApi from '../../AbstractCasinoCRMApi';
import { GetAllCasinoGameTypeResponse } from '../Responses/CasinoGameResponse';

class CasinoGameApi extends AbstractCasinoCRMApi {
    public async getAllTypes(): Promise<GetAllCasinoGameTypeResponse> {
        return (await this.get(API_CASINO_GAME_TYPES)).data;
    }

    // eslint-disable-next-line camelcase
    public changeSeoTag(data: { id: number; casino_game_seo_tag_id: number }): Promise<AxiosResponse> {
        return this.post(API_CASINO_CHANGE_SEO_TAG_FOR_GAME, data);
    }
}

export default new CasinoGameApi();
